import { createResourceSlice, resourceInitialState } from 'store/ResourceSlice';
import { CancelReasonState } from 'features/CancelReason/types';

export const initialState: CancelReasonState = resourceInitialState();

const slice = createResourceSlice({ name: 'cancelReason', initialState });

export const cancelReason = slice.reducer;
export const actions: typeof slice.actions = slice.actions;
